/* Dropdayz — mobiele navigatie, aanvullingen.

   Alles hier is progressieve verbetering: zonder JavaScript werkt de la
   precies zoals hij uit sections/header.liquid komt. Elke stap is afgeschermd,
   dus een wijziging in de markup levert een no-op op in plaats van een fout.

   25 EN 26 AUGUSTUS 2026 — DRIE BLOKKEN HIER WEGGEHAALD, want ze zijn nu bij
   de bron in sections/header.liquid opgelost:
     * het weghalen van de dubbele "Shop"-groep;
     * de kop van het Categories-blok (dat blok is inmiddels helemaal weg);
     * het vastpinnen van "Alle sneakers" en "Alle kleding" bovenaan de
       merkenlijsten. Die knoppen staan nu gewoon in de markup.

   WAT HIER NOG WEL GEBEURT
   1. Sluitbalk bovenaan — klikt de bestaande hamburger
      (aria-controls="MobileNav"), zodat de la-logica van het thema de enige
      waarheid blijft.
   2. Het infoblok omgebouwd naar dezelfde opzet als de voettekst.
      DEZE LINKS MOETEN GELIJK BLIJVEN LOPEN met snippets/ddz-footer-info.liquid.
   3. De naam van de aanvraagpagina gelijkgetrokken — zie hieronder.

   ============================================================
   "SNEAKER REQUEST" HEET "OP AANVRAAG" — 27 augustus 2026
   ============================================================
   Sinds die dag kun je ook kleding en accessoires aanvragen, dus "sneaker"
   klopte niet meer. De link staat op DRIE plekken in de site:

     a) de voettekst   -> snippets/ddz-footer-info.liquid, daar aangepast
     b) de servicelijst in de mobiele la -> hieronder in MAIN, aangepast
     c) een losse regel bovenin de mobiele la, met een pijltje
        (.ddz-mnav-section-head) -> die komt uit sections/header.liquid

   Voor (c) staat hieronder een tekstcorrectie in plaats van een aanpassing
   in header.liquid zelf. Dat is een bewuste keuze: header.liquid is 38 kB en
   bevat de hele koptekst, de megamenu's en de mobiele la. Op de dag van de
   livegang dat bestand openen om één woord te wijzigen is een risico dat niet
   in verhouding staat. Dit bestand bestaat juist om de mobiele la bij te
   sturen, dus het hoort hier ook niet vreemd.

   NA DE LAUNCH: zet de tekst gewoon goed in sections/header.liquid en haal
   blok 3 hieronder weg.

   DE URL BLIJFT /pages/sneaker-request. Die omzetten vraagt een omleiding en
   levert de klant niets op.

   HOME-KNOP IN DE SLUITBALK — 26 augustus 2026.
   Eigenaar: "mis alleen een button die mij weer naar home brengt ofzo".

   Terecht. Op een telefoon dekt de la het hele scherm af, dus ook het logo in
   de koptekst — en dat logo is normaal de weg terug naar de homepagina. Zolang
   het menu openstond was er dus geen enkele route naar huis behalve eerst
   sluiten en dan het logo zoeken.

   Links in die balk stond het woord "Menu", dat niets deed en niets vertelde
   wat de gebruiker niet al wist: hij had zojuist zelf het menu geopend. Die
   plek is nu de home-knop. Geen extra regel in de lijst, geen ruimte erbij,
   en hij staat waar een logo normaal ook staat: linksboven.

   Waarom een huisje met het woord HOME en niet het Dropdayz-woordmerk: een
   afbeelding heeft een pad naar assets nodig, en dat pad kan dit bestand niet
   opbouwen — dat kan alleen Liquid. Tekst met een icoon werkt altijd, ook als
   er ooit aan de assets geschud wordt. */
(function () {
  var nav = document.getElementById('MobileNav');
  if (!nav) { return; }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(path){ return ROOT.replace(/\/$/, '') + path; }

  /* ---- 1. sluitbalk, met de home-knop links ---- */
  try {
    if (!nav.querySelector('.ddz-mnav-close')) {
      var bar = document.createElement('div');
      bar.className = 'ddz-mnav-close';
      bar.innerHTML =
        '<a class="ddz-mnav-close__home" href="' + (ROOT || '/') + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M3 11l9-8 9 8"/><path d="M5 10v10h5v-6h4v6h5V10"/></svg>Home</a>' +
        '<button type="button" class="ddz-mnav-close__btn" aria-label="Menu sluiten">Sluiten' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
        '<path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      nav.insertBefore(bar, nav.firstChild);
      bar.querySelector('button').addEventListener('click', function () {
        var toggle = document.querySelector('button[aria-controls="MobileNav"]');
        if (toggle) { toggle.click(); }
      });
    }
  } catch (e) {}

  /* ---- 2. infoblok omgebouwd naar de opzet van de voettekst ---- */
  try {
    var info = nav.querySelector('.ddz-mnav-info');
    if (info && !info.querySelector('.ddz-mnav-service')) {
      var MAIN = [
        ['Veelgestelde vragen', url('/pages/faq')],
        ['Verzending & retour', url('/pages/verzending-en-retour')],
        ['Retour aanmelden', url('/pages/retour-aanmelden')],
        ['Op aanvraag', url('/pages/sneaker-request')],
        ['Authenticiteit', url('/pages/authenticiteit')],
        ['Over ons', url('/pages/over-ons')],
        ['Contact', url('/pages/contact')],
        ['Winkel Kortrijk', url('/#dropdayz-store')]
      ];
      var LEGAL = [
        ['Mijn account', url('/account/login')],
        ['Retourbeleid', url('/policies/refund-policy')],
        ['Algemene voorwaarden', url('/policies/terms-of-service')]
      ];
      var html = '<div class="ddz-mnav-service">' +
        '<span class="ddz-mnav-service__head">Klantenservice</span>';
      MAIN.forEach(function (l) {
        html += '<a class="ddz-mnav-service__link" href="' + l[1] + '">' + l[0] + '</a>';
      });
      html += '<span class="ddz-mnav-service__rule"></span>';
      LEGAL.forEach(function (l) {
        html += '<a class="ddz-mnav-service__link ddz-mnav-service__link--small" href="' + l[1] + '">' + l[0] + '</a>';
      });
      html += '</div>';
      info.innerHTML = html;
    }
  } catch (e) {}

  /* ---- 3. de losse regel met het pijltje: "Sneaker request" -> "Op aanvraag"
           Alleen de tekst; de link en het pijltje blijven zoals ze zijn.
           Tijdelijk, hoort in sections/header.liquid — zie de kop. ---- */
  try {
    var koppen = nav.querySelectorAll('a.ddz-mnav-section-head[href*="sneaker-request"]');
    Array.prototype.forEach.call(koppen, function (a) {
      var s = a.querySelector('span') || a;
      if (/sneaker\s*request/i.test(s.textContent)) { s.textContent = 'Op aanvraag'; }
    });
  } catch (e) {}
})();
